/**
 * NewForm design-system Skeleton.
 *
 * Loading-state placeholder block. Subtle animated pulse on a neutral
 * tinted surface — pairs with the gray page panel + white card surfaces
 * without competing visually.
 *
 *   import { Skeleton } from "@/components/ui/design-system/skeleton";
 *
 *   <Skeleton className="h-6 w-40" />
 *
 * Use sparingly: a page-level skeleton should mimic the loaded
 * layout's structure (cards, rows, KPI tiles) — not just stack random
 * bars. See `BatchDetailsSkeleton.tsx` for the canonical example.
 *
 * Default rounding is `rounded-nf-ds-md` (8px) to match the DS card
 * radius. Override with className for pill-shaped placeholders
 * (`rounded-full`) or full-bleed banners (`rounded-nf-ds-lg`).
 */

import type { HTMLAttributes } from "react";
import { cn } from "@/lib/utils";

export function Skeleton({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      aria-hidden
      className={cn(
        "animate-pulse rounded-nf-ds-md bg-foreground/[0.06]",
        className,
      )}
      {...props}
    />
  );
}
